export const COOKIE_NAME = 'dashboard.frontend.v2';
